import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { setActiveLayout } from "../../../helpers/product";

const ShopTopAction = ({
  getLayout,
  getFilterSortParams,
  productCount,
  sortedProductCount,
  sortBy,
}) => {
  const { t } = useTranslation();

  return (
    <div className="shop-top-bar mb-35">
      <div className="select-shoing-wrap">
        <div className="shop-select">
          <select
            value={sortBy}
            onChange={(e) => getFilterSortParams(e.target.value)}
          >
            <option value="-updatedAt">{t("productList.newArrivals")}</option>
            <option value="price">{t("productList.priceLowToHigh")}</option>
            <option value="-price">{t("productList.priceHighToLow")}</option>
          </select>
        </div>
        <p>
          {t("productList.numOfResult", {
            current: sortedProductCount,
            total: productCount,
          })}
        </p>
      </div>

      {/* <div className="shop-tab"> */}
      {/*  <button */}
      {/*    onClick={e => { */}
      {/*      getLayout("grid two-column"); */}
      {/*      setActiveLayout(e); */}
      {/*    }} */}
      {/*  > */}
      {/*    <i className="fa fa-th-large" /> */}
      {/*  </button> */}
      {/*  <button */}
      {/*    onClick={e => { */}
      {/*      getLayout("grid three-column"); */}
      {/*      setActiveLayout(e); */}
      {/*    }} */}
      {/*  > */}
      {/*    <i className="fa fa-th" /> */}
      {/*  </button> */}
      {/*  <button */}
      {/*    onClick={e => { */}
      {/*      getLayout("list"); */}
      {/*      setActiveLayout(e); */}
      {/*    }} */}
      {/*  > */}
      {/*    <i className="fa fa-list-ul" /> */}
      {/*  </button> */}
      {/* </div> */}
    </div>
  );
};

ShopTopAction.propTypes = {
  getFilterSortParams: PropTypes.func,
  getLayout: PropTypes.func,
  productCount: PropTypes.number,
  sortedProductCount: PropTypes.number,
};

export default ShopTopAction;
